import * as React from "react";
const SvgFiRrStarfighter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-starfighter_svg__a)">
      <path
        fill="#062147"
        d="M23 6a1 1 0 0 0-1 1v7h-6.017C15.7-4.73 8.3-4.671 8.017 14H2V7a1 1 0 0 0-2 0v13a1 1 0 1 0 2 0v-.586l3.878 3.878A2.433 2.433 0 0 0 9.965 22h4.07a2.433 2.433 0 0 0 4.086 1.293L22 19.414V20a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m-13 9c.004-2.5.184-4.998.536-7.473a2.274 2.274 0 0 1 2.928 0A54 54 0 0 1 14 15v5h-4zm3.046-9.849a4.4 4.4 0 0 0-2.092 0A8.6 8.6 0 0 1 12 2.093c.54.944.895 1.982 1.046 3.058M8 21.586a.43.43 0 0 1-.707.293L2 16.586V16h6zm8.706.293a.43.43 0 0 1-.706-.293V16h6v.586z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-starfighter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarfighter;
